"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _View = _interopRequireDefault(require("react-native-web/dist/exports/View"));

var _ = require("..");

var _styles = _interopRequireDefault(require("./styles"));

var _quarkWeb = require("quark-web");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// needs to be a class to hold references
var Select =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Select, _React$Component);

  function Select(props) {
    var _ref;

    var _this;

    _classCallCheck(this, Select);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    // instantiate this
    _this = _possibleConstructorReturn(this, (_ref = Select.__proto__ || Object.getPrototypeOf(Select)).call.apply(_ref, [this, props].concat(args))); // set the initial state to match the value prop

    _this.render = function () {
      return React.createElement(_.Dropdown, {
        toggle: _this._toggleElement,
        max: _this._options.length,
        style: _extends({
          width: 200
        }, _this.props.style),
        dropdownStyle: {
          maxHeight: 280
        }
      }, function (_ref2) {
        var keyIdx = _ref2.index,
            setIndex = _ref2.setIndex,
            toggle = _ref2.toggle;
        return _toConsumableArray(_this._children.map(function (child, optionIdx) {
          // grab any previously defined onClick handlers
          var _onClick = child.props.onClick || function () {};

          var _onMouseOver = child.props.onMouseOver || function () {}; // add the required event handlers and props to the option


          return React.cloneElement(child, {
            key: child.props.value,
            active: keyIdx === optionIdx,
            selected: _this.state.value === child.props.value,
            onMouseOver: function onMouseOver(evt) {
              _onMouseOver(evt);

              setIndex(optionIdx);
            },
            onClick: function onClick(evt) {
              _onClick(evt);

              _this._onChange({
                index: optionIdx,
                toggle: toggle
              });
            }
          });
        })).concat([React.createElement(_quarkWeb.EventListener, {
          event: "keydown",
          filter: function filter(evt) {
            return evt.which === 13;
          },
          key: "event-listener"
        }, function (evt) {
          // prevent unwanted bubbling
          evt.preventDefault(); // we're done

          _this._onChange({
            index: keyIdx,
            toggle: toggle
          });
        })]);
      });
    };

    _this._onChange = function (_ref3) {
      var toggle = _ref3.toggle,
          index = _ref3.index;
      // the value of the appropriate option
      var value = _this._options[index].props.value; // if there is a callback to trigger

      if (_this.props.onChange) {
        // pass the value to the parent
        _this.props.onChange(value);
      } // if there is no value prop then update the component state


      if (typeof _this.props.value === 'undefined' || _this.props.value === 'null') {
        // save the value
        _this.setState({
          value: value
        });
      } // close the dropdown


      toggle();
    };

    _this.state = {
      value: props.value
    };
    return _this;
  }

  _createClass(Select, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // if the value has changed
      if (nextProps.value !== this.state.value) {
        // update the internal tracker
        this.setState({
          value: nextProps.value
        });
      }
    } // the list of options in the select

  }, {
    key: "_toggleElement",
    get: function get() {
      var _this2 = this;

      // the content of the toggle element
      var content; // find the child we have selected

      var selectedChild = this._options.find(function (child) {
        return child.props.value === _this2.state.value;
      }); // if we dont have a value to show or couldn't find a matching child


      if (!this.props.value || !selectedChild) {
        // return null if we have a placeholder, otherwise the first child is selected
        content = this.props.placeholder || this._children[0].props.children;
      } else {
        content = selectedChild.props.children;
      }

      return React.createElement(_View.default, {
        style: _extends({}, _styles.default.toggle, this.props.toggleStyle)
      }, React.createElement(_quarkWeb.Text, {
        style: {
          marginRight: 4
        }
      }, content), React.createElement(_quarkWeb.IconChevronDown, null));
    }
  }, {
    key: "_options",
    get: function get() {
      return this._children;
    } // the flat list of options

  }, {
    key: "_children",
    get: function get() {
      return React.Children.toArray(this.props.children);
    }
  }]);

  return Select;
}(React.Component);

var _default = Select;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-web/components/form/Select/index.js
// module id = ./node_modules/quark-web/components/form/Select/index.js
// module chunks = 0